import React from 'react';
import './ContactUs.css'

const CotactUs = () => {
    return (
        <div className='CotactForm'>
            <div className="wrapper">
                <h2>CONTACT US</h2>
                <form action="" method="POST">
                    <div className="form-group">
                        <label>Full Name</label>
                        <input type="text" name="Name" id="name" placeholder="First and Last" required minLength="3" maxLength="25" />
                    </div>
                    <div className="form-group">
                        <label>Email Address</label>
                        <input type="email" name="Email" id="email" placeholder="email@domain.tld" required />
                    </div>
                    <div className="form-group">
                        <label>Message</label>
                        <textarea name="Message" id="message" rows="5" placeholder="Type your message here...."></textarea>
                    </div>
                    <div className="form-group">
                        <button type="submit" className="submit btn d-block btn-outline-info"><i className="far fa-paper-plane"></i>Send</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CotactUs;